<template> 
    <div class="px-5 " data-cy="container_serial_mark_used">
        <button class="w-full h-11 mb-5 mt-2 bg-gold text-dark-3 rounded-5px border-2 border-transparent shadow capitalize  text-16 font-medium font-main-medium"
        @click="clickOk()"
        data-cy="btn_serial_mark_used_confirm">
            {{btnOk}}
        </button>
    </div>
</template>
<script> 
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "MarkUsed",
    mixins: [LocaleMixin],
    emits: ["onClick"],
    props: { 
    },
    data: function() {
        return { 
            btnOk: ""
        };
    },
    created: function() { 
        this.btnOk = this.lbl.customHistory.mark_used
    },
    methods: {
        clickOk: function() {  
            this.$emit('onClick');
        }, 
    },
}
</script>
<style lang="scss" scoped>
</style>
